import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'art-ui-labels-v1';

const defaultContext = {
    isEditMode: false,
    toggleEditMode: () => {},
    getLabel: (key, defaultValue) => defaultValue,
    setLabel: () => {},
    resetAll: () => {},
    customizations: {},
};

const EditModeContext = createContext(defaultContext);

export function EditModeProvider({ children }) {
    const [isEditMode, setIsEditMode] = useState(false);
    const [customizations, setCustomizations] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        } catch {
            return {};
        }
    });

    const toggleEditMode = useCallback(() => setIsEditMode(v => !v), []);

    const getLabel = useCallback((key, defaultValue) => {
        return customizations[key] ?? defaultValue;
    }, [customizations]);

    const setLabel = useCallback((key, value) => {
        setCustomizations(prev => {
            const next = { ...prev, [key]: value };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }, []);

    const resetAll = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setCustomizations({});
    }, []);

    return (
        <EditModeContext.Provider value={{ isEditMode, toggleEditMode, getLabel, setLabel, resetAll, customizations }}>
            {children}
        </EditModeContext.Provider>
    );
}

export function useEditMode() {
    return useContext(EditModeContext);
}

export default EditModeContext;
